function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import StyledGlobalStyle from './GlobalStyle.style';
GlobalStyle.propTypes = {
  /** normalize css for better cross browser rendering */
  normalize: PropTypes.bool,

  /** set all elements to use box-sizing: border-box */
  borderBox: PropTypes.bool,

  /** load NAB Impact font faces @font-face name: NABImpact */
  fontImpact: PropTypes.bool,

  /** load NAB Accent font faces @font-face name: NABScript */
  fontAccent: PropTypes.bool,

  /** load NAB Source Sans Pro font faces @font-face name: SourceSansPro */
  fontSourceSansPro: PropTypes.bool,

  /** set the custom CDN Path to read the fonts from */
  customCDN: PropTypes.shape({
    assetsPath: PropTypes.shape({
      fonts: PropTypes.string.isRequired
    }).isRequired,
    cdnUrl: PropTypes.string.isRequired
  })
};
GlobalStyle.defaultProps = {
  normalize: false,
  borderBox: false,
  fontImpact: false,
  fontAccent: false,
  fontSourceSansPro: true
};
export function GlobalStyle(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(StyledGlobalStyle, props);
}